import { render } from "./Waitlist.vue?vue&type=template&id=3d9ed5aa&scoped=true"
import script from "./Waitlist.vue?vue&type=script&lang=js"
export * from "./Waitlist.vue?vue&type=script&lang=js"

import "./Waitlist.vue?vue&type=style&index=0&id=3d9ed5aa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9ed5aa"]])

export default __exports__